const TOKEN_KEY = '@controleEstoqueToken';
const REFRESH_TOKEN_KEY = '@controleEstoqueRefreshToken';
const USER_ID = '@userId';
const USERNAME = '@username';
export const SESSION_ID = '@sessionId';
const VENDA_NAO_CANCELADA = '@vendaNaoCancelada';
const VENDA_RASCUNHO_UUID = '@vendaRascunhoUuid';

export const getUuidVendaRascunho = () => localStorage.getItem(VENDA_RASCUNHO_UUID);

export const setUuidVendaRascunho = (uuid) => {
  if(uuid) {
    localStorage.setItem(VENDA_RASCUNHO_UUID, uuid);
  } else {
    localStorage.removeItem(VENDA_RASCUNHO_UUID)
  }
}

export const getVendaCancelada = () => {
  const str = localStorage.getItem(VENDA_NAO_CANCELADA)
  if(str) {
    return JSON.parse(str)
  } else {
    return null
  }
}

export const setVendaCancelada = (obj) => {
  if(obj) {
    const str = JSON.stringify(obj)
    localStorage.setItem(VENDA_NAO_CANCELADA, str);
  } else {
    localStorage.removeItem(VENDA_NAO_CANCELADA)
  }
}

export const isAuthenticated = () => {
  const isAuth = localStorage.getItem(REFRESH_TOKEN_KEY) !== null;
  return isAuth;
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

export const login = (token, refreshToken) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

export const setNewToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USERNAME);
  localStorage.removeItem(USER_ID);
};

export const setUsername = (username) => localStorage.setItem(USERNAME, username);

export const getUsername = () => localStorage.getItem(USERNAME);

export const setUserId = (userId) => localStorage.setItem(USER_ID, String(userId));

export const getUserId = () => {
  const userIid = String(localStorage.getItem(USER_ID));
  return parseInt(userIid, 10);
};

export const setSessionId = (sessionId) => localStorage.setItem(SESSION_ID, String(sessionId));

export const getSessionId = () => {
  const sessionId = localStorage.getItem(SESSION_ID);
  return parseInt(sessionId, 10);
};
